import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestSection() {
  const latestArticles = articles.slice(0, 8);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat?.name || slug;
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新内容
            </h2>
            <p className="text-foreground-500 text-sm">每日更新，精彩不断</p>
          </div>
          <Link
            to="/category/zuixin-jingxuan"
            className="hidden sm:inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md mb-2">
                  {getCategoryName(article.category)}
                </span>
                <h3 className="text-sm font-heading font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/zuixin-jingxuan"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部最新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}